import React, { useEffect, useState } from 'react'
import DatePicker from '../../../shared/DatePicker'
import moment from 'moment'
import { useTranslation } from 'react-i18next'
import CustomButton from '../../../shared/CustomButton'
import DropdownField from '../../../shared/DropdownField'
import { fetchData } from '../../../helpers/fetchData'
import { practionerOptionsFormat } from '../../../constants/VisitsConstants'
import { validateOneMonthRange, getMinDate, getOneMonthMaxDate } from '../../../utils/dateRangeValidation'

function DoctorRepFilter({ payloadData, setPayloadData, filterData, loading }) {
  const { t, i18n } = useTranslation()
  const [practitioners, setPractitioners] = useState([])
  const [departments, setDepartments] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [practitonerLoading, setPractitionerLoading] = useState(false)
  const fetchDepartments = async () => {
    setIsLoading(true)
    try {
      const departmentResponse = await fetchData('POST', '/v3/department/getList', {})

      if (departmentResponse?.data) {
        setDepartments(departmentResponse.data)
      }
    } catch (error) {
      console.error('Error fetching dropdown data:', error)
    } finally {
      setIsLoading(false)
    }
  }

  const fetchAllPractitioners = async () => {
    setPractitionerLoading(true)
    try {
      const response = await fetchData('GET', '/v3/practitioner/getAllPractitioners', {
        perPage: 0,
      })
      if (response?.practitioners) {
        setPractitioners(practionerOptionsFormat(response.practitioners))
      }
    } catch (error) {
      console.error('Error fetching practitioners:', error)
    } finally {
      setPractitionerLoading(false)
    }
  }

  const getPractitionerListData = async (dep_name) => {
    setPractitionerLoading(true);
    const response = await fetchData(
      "POST",
      `/v3/practitioner/getByDepartmentId?department_id=${dep_name}`,
      {}
    );
    setPractitionerLoading(false);
    let formatedData = response?.practitioners
      ? practionerOptionsFormat(response?.practitioners)
      : [];
    setPractitioners(formatedData);
  };

  const handleChange = event => {
    const { name, value } = event.target || {}
    if (name === 'department_id') {
      if (value) {
        getPractitionerListData(value);
      } else {
        fetchAllPractitioners();
      }
    }
    setPayloadData(prevValues => ({
      ...prevValues,
      [name]: value,
    }))
  }

  const handleApply = async () => {
    if (!validateOneMonthRange(payloadData?.start_date, payloadData?.end_date, t)) return
    await filterData(payloadData)
  }

  const handleResetFilters = () => {
    let payload = {
      start_date: moment().subtract(6, 'days').format('YYYY-MM-DD'),
      end_date: moment().format('YYYY-MM-DD'),
      practitioner_id: '',
      department_id: '',
    }
    filterData(payload)
    setPayloadData(payload)
    fetchAllPractitioners()
  }

  useEffect(() => {
    fetchDepartments()
    fetchAllPractitioners()
  }, [])


  return (
    <div className="grid grid-cols-12 lg:grid-cols-11 gap-x-3 mb-2">
      <DatePicker
        name="start_date"
        value={
          payloadData?.start_date
            ? moment(payloadData?.start_date, 'YYYY-MM-DD').toDate()
            : ''
        }
        onChange={handleChange}
        useFormik={false}
        placeholder={t('StartDate')}
        className="col-span-12 md:col-span-4 lg:col-span-2"
      />
      <DatePicker
        name="end_date"
        value={
          payloadData?.end_date
            ? moment(payloadData?.end_date, 'YYYY-MM-DD').toDate()
            : ''
        }
        onChange={handleChange}
        useFormik={false}
        placeholder={t('EndDate')}
        className="col-span-12 md:col-span-4 lg:col-span-2"
        minDate={getMinDate(payloadData?.start_date)}
        maxDate={getOneMonthMaxDate(payloadData?.start_date)}
      />
      <DropdownField
        useFormik={false}
        name="department_id"
        onChange={handleChange}
        filter
        value={payloadData?.department_id}
        className="col-span-12 md:col-span-4 lg:col-span-2"
        placeholder={t("SelectDepartment")}
        options={departments}
        optionLabel={`name_${i18n.language}`}
        optionValue="id"
        disabled={isLoading}
      />
      <DropdownField
        loading={practitonerLoading}
        useFormik={false}
        name="practitioner_id"
        onChange={handleChange}
        filter
        value={payloadData?.practitioner_id}
        className="col-span-12 md:col-span-4 lg:col-span-2"
        placeholder={t("SelectPractitioner")}
        options={practitioners}
        disabled={practitonerLoading}
      />

      <div className="flex items-center gap-2 mb-3 col-span-12 md:col-span-4 lg:col-span-4 xl:col-span-3">
        <CustomButton
          //label={t('ApplyFilters')}
          title={t('ApplyFilters')}
          buttonType="primary"
          icon={'pi pi-filter'}
          className="w-fit h-[35px]"
          disabled={loading || isLoading}
          onClick={handleApply}
        />
        <CustomButton
          //label={t('Reset')}
          title={t('Reset')}
          buttonType="reset"
          icon={'pi pi-sync'}
          disabled={loading || isLoading}
          className="w-fit h-[35px]"
          onClick={handleResetFilters}
        />
      </div>
    </div>
  )
}

export default DoctorRepFilter
